const Skill = {
    normal: 'Saya',
    strong: 'Skill',
    desc: 'Klik untuk Informasi Selengkapnya!',
    content: [
        {
            name: 'Web Developer',
            items: ['React JS', 'Django', 'Bootstrap', 'Tailwind CSS']
        },
        {
            name: 'Mobile Developer',
            items: ['React Native', 'Android Studio WebView']
        },
        {
            name: 'Python',
            items: ['Django REST API', 'FAST API', 'Web Scraping', 'Telegram Bot']
        },
    ]
}

export default Skill